import SearchResults from "./src/SearchResults";

export default SearchResults;